export const TOTAL_AMOUNT_CAN_CHANGE = true;



// WEBPACK FOOTER //
// ./src/payments/constants/GlobalConstants.js